// Убрать учётную запись из системы.
//
// Заказчик 13.09.2026: «не нашёл вкладку удалить созданного пользователя, возможно оно у меня
// у Финдира как у админа? У Админа тоже нет клавиши удалить». Её и не было: ни кнопки, ни
// маршрута, ни кода права — при том что тз даёт администратору по строке «Пользователи и
// права» уровень «полный», в определение которого удаление входит явно.
//
// Модалка — ровно тот случай, ради которого она оставлена (правило 4): необратимое действие,
// которое надо подтвердить. Окно называет ПОСЛЕДСТВИЯ, а не спрашивает «вы уверены»:
// уверенность человека не информация, информация — что исчезнет и что останется.
//
// Основание здесь НЕ спрашиваем, в отличие от стирания записи чёрного списка: там уничтожаются
// персональные данные и повод остаётся в журнале навсегда, здесь же убирается учебная запись, и
// обязательная строка помешала бы убрать десяток таких подряд.
//
// Окно УПРАВЛЯЕТСЯ СНАРУЖИ и на панели одно на всех, а не по штуке в каждой строке: открывает
// его пункт меню «Ещё», а двадцать невидимых окон в разметке — это двадцать лишних узлов,
// которые находит чтение с экрана.

import { RiDeleteBinLine } from '@remixicon/react';

import * as Button from '@/shared/ui/button';
import { ErrorAlert } from '@/shared/ui/error-alert';
import * as Modal from '@/shared/ui/modal';

export function УдалениеУчётнойЗаписи({
  кого,
  идёт,
  ошибка,
  закрыть,
  убрать,
}: {
  кого: { display_name: string; login: string } | null;
  идёт: boolean;
  ошибка: unknown;
  закрыть: () => void;
  убрать: () => void;
}) {
  return (
    <Modal.Root
      open={кого !== null}
      onOpenChange={(следующее) => {
        if (!следующее) {
          закрыть();
        }
      }}
    >
      <Modal.Content>
        <Modal.Header
          icon={RiDeleteBinLine}
          title="Убрать учётную запись?"
          // Имя отдельной фразой, а не внутри вопроса: по-русски «Убрать Старцев Иван?» — это
          // именительный падеж там, где нужен винительный, а склонять фамилии в коде нельзя.
          description={
            кого === null
              ? ''
              : `${кого.display_name}, вход «${кого.login}». Вернуть запись этим экраном будет нельзя.`
          }
        />
        <Modal.Body>
          <ul className='flex flex-col gap-1.5 text-paragraph-sm text-text-sub-600'>
            <li>Запись пропадёт из списка.</li>
            <li>Имя входа освободится: его сразу можно выдать другому человеку.</li>
            <li>
              Код для телефона, если он у человека на руках, перестанет работать. Открытые окна
              программы закроются.
            </li>
            <li>
              Всё, что человек делал раньше, останется: деньги, ведомости, переписка и журнал.
              Без этого цифры перестали бы сходиться.
            </li>
          </ul>
          {/* Половина обращений «удалите его» на деле про временный уход: человек уехал с
              вахты и вернётся. Для этого есть «Закрыть доступ», и сказать об этом надо
              ЗДЕСЬ, а не прятать кнопку. */}
          <p className='mt-3 text-paragraph-xs text-text-sub-600'>
            Если человек уезжает и вернётся, лучше не убирать его, а закрыть доступ: тогда имя
            входа остаётся за ним.
          </p>
          {ошибка !== null && ошибка !== undefined && (
            <ErrorAlert error={ошибка as never} className='mt-3' />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Modal.Close asChild>
            <Button.Root variant='neutral' mode='stroke' size='small' className='w-full'>
              Отмена
            </Button.Root>
          </Modal.Close>
          <Button.Root
            variant='error'
            mode='filled'
            size='small'
            className='w-full'
            type='button'
            onClick={убрать}
          >
            {идёт ? 'Убираем…' : 'Убрать из системы'}
          </Button.Root>
        </Modal.Footer>
      </Modal.Content>
    </Modal.Root>
  );
}
